import { makeAxiosClient } from 'lib/api/ssapi/secondStepClient'
import { domains, isCurriculumDraftMode } from 'config/env'
import { formatError } from 'utils/formatError'
import { actions } from './reducer'
import { createCurriculumCourseStateKey } from './selectors'

const getClient = () => makeAxiosClient(domains.CURRICULUM_SERVICE)

/**
 * Fetch a single course tree from the curriculum service
 * POST /v1/audienced-course-versions endpoint.
 *
 * Replaces the legacy `@cfc/course-manager-sdk` getCourseTree call.
 * Audience inputs come from SSAPI via the bearer JWT (set by makeAxiosClient).
 */
const fetchCurriculumCourseTree = ({
  contentGroupCode,
  courseCode,
  siteId,
  resolutionMode = 'singleSite',
  includePlaceholders,
  audienceMapVersion,
}) => {
  return async dispatch => {
    const courseStateKey = createCurriculumCourseStateKey(
      contentGroupCode,
      courseCode,
      siteId,
    )
    dispatch(actions.fetchingCourseTree({ courseStateKey }))

    try {
      const client = getClient()
      const body = {
        resolutionMode,
        contentGroupCode,
        courseCode,
        ...(siteId != null ? { siteId } : {}),
        ...(includePlaceholders != null ? { includePlaceholders } : {}),
        ...(audienceMapVersion ? { audienceMapVersion } : {}),
      }

      // In non-prod/non-staging envs the curriculum-service seeded content
      // groups are in DRAFT status; ask the service to resolve from
      // draft-or-published so local/dev/test work end-to-end without
      // requiring publishing pipelines to run first.
      const url = isCurriculumDraftMode()
        ? '/v1/audienced-course-versions?draftMode=true'
        : '/v1/audienced-course-versions'
      const response = await client.post(url, body)
      dispatch(
        actions.fetchCourseTreeSuccess({
          courseStateKey,
          data: response.data,
        }),
      )
    } catch (error) {
      dispatch(
        actions.fetchCourseTreeError({
          courseStateKey,
          error: formatError(error),
        }),
      )
    }
  }
}

const clearErrors = () => {
  return async dispatch => {
    dispatch(actions.clearErrors())
  }
}

export default {
  fetchCurriculumCourseTree,
  clearErrors,
}
